import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import { type RecipeCartState } from '../../../../recipe/hooks/useRecipeCart';
import type {
    RecipeCalculationType,
    RecipeItemState,
    RecipePrioritizationType,
} from '../../../../recipe/models';
import styles from './BuyableRecipe.module.scss';
import BuyableRecipeCalculationTypes from './BuyableRecipeCalculationTypes';
import BuyableRecipeCartFooter from './BuyableRecipeCartFooter';
import BuyableRecipeCartSections from './BuyableRecipeCartSections';
import BuyableRecipeCartTotalPriceAnnouncer from './BuyableRecipeCartTotalPriceAnnouncer';
import BuyableRecipePortionCounter from './BuyableRecipePortionCounter';

const BuyableRecipeCart = (props: {
    recipeId: string;
    portions: number;
    recipeCart: RecipeCartState | null;
    recipeCartProducts: ApiProduct[];
    onItemQuantityChange: (item: RecipeItemState, newQuantity: number) => void;
    onItemRemove: (item: RecipeItemState) => void;
    onPortionChange: (portions: number) => void;
    onCalculationTypeChange: (
        calculationType: RecipeCalculationType,
        prioritization: RecipePrioritizationType | null,
    ) => void;
    onBuyClick: () => void;
}) => {
    if (!props.recipeCart) {
        return null;
    }

    return (
        <div className={styles.Cart}>
            <div className={styles.PortionCounterContainer}>
                <BuyableRecipePortionCounter
                    defaultPortions={props.portions}
                    setPortions={props.onPortionChange}
                    minValue={1}
                    maxValue={20}
                    incrementBy={1}
                />
            </div>
            <BuyableRecipeCalculationTypes
                calculationType={props.recipeCart.calculation || 'waste'}
                prioritizationType={props.recipeCart.prioritization || null}
                handleCalculationTypeChange={props.onCalculationTypeChange}
            />
            <BuyableRecipeCartSections
                cart={props.recipeCart}
                cartProducts={props.recipeCartProducts}
                onItemQuantityChange={props.onItemQuantityChange}
                onItemRemove={props.onItemRemove}
            />
            {/* fills the space between cart items and footer if cart items are not full height, so we can use sticky still instead of fixed */}
            <div className={styles.FillSpace} />
            <BuyableRecipeCartFooter recipeCart={props.recipeCart} onBuyClick={props.onBuyClick} />
            <BuyableRecipeCartTotalPriceAnnouncer
                recipeCart={props.recipeCart}
                announcerName="BuyableRecipeCartAnnouncer"
            />
        </div>
    );
};

export default BuyableRecipeCart;
